// removed by extract-text-webpack-plugin
module.exports = {"container":"src-routes-Test__container__1-mtr","testText":"src-routes-Test__testText__2tnO_","buttons":"src-routes-Test__buttons__1dXKi"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Test.css
// module id = 368
// module chunks = 0